import Card from '@mui/material/Card';

export { Card };
